import type { IMetaDataFormHook } from '../../../app/electoral-divisions/constituency/utils';
import type {
	IConstituencyByIDState,
	IConstituencyStates,
	ILGAConstituencyStates,
	ILGAInConstituencyStates,
	IWardConstituencyStates,
	IWardInConsistuency,
} from '../../../interface/state/IConstituencyState';
import type { IConstituencyLGAs } from '../../../interface/state/ILGAState';
import { constituencyType } from '../../types';
import { createAPI, deleteByIdAPI, getAPI, getByIdAPI, getByNameAPI, getFetchAPI, updateAPI, updateByIdAPI } from '../api-utils';

export const create = createAPI<undefined, ICreateUpdateConstituency>({
	actionType: constituencyType.create,
	url: '/api/v1/Constituency',
});

export const getByStateId = getFetchAPI<IConstituencyStates, { stateId: number; name: string }>({
	actionType: constituencyType.getByStateId,
	url: '/api/v1/Constituency/get-constituency-by-stateid',
});

export const get = getAPI<IConstituencyStates>({
	actionType: constituencyType.get,
	url: '/api/v1/Constituency',
	type: 'core',
});

export const getByID = getByIdAPI<IConstituencyByIDState>({
	actionType: constituencyType.getByID,
	url: '/api/v1/Constituency',
});

export const getByName = getByNameAPI({
	actionType: constituencyType.getByName,
	url: '/api/v1/Constituency/name',
});

export interface ICreateUpdateConstituency {
	id?: number;
	lgaCount: number;
	wardCount: number;
	pollingUnitCount: number;
	name: string;
	code: string;
	alias: string;
	stateId: number;
	electiveCategoryId: number;
	isCouncilorship: boolean;
}

export const update = updateAPI<undefined, ICreateUpdateConstituency>({
	actionType: constituencyType.update,
	url: '/api/v1/Constituency/update',
});

export const deleteById = deleteByIdAPI({
	actionType: constituencyType.deleteById,
	url: '/api/v1/Constituency/delete',
});

// Constituency lga

export const createLGA = createAPI<undefined, { constituencyId: number; lgaId: number }>({
	actionType: constituencyType.createLGA,
	url: '/api/v1/ConstituencyLga',
});

export const getLGA = getAPI<IConstituencyLGAs>({
	actionType: constituencyType.getLGA,
	url: '/api/v1/ConstituencyLga',
	type: 'core',
});

export const getLGAIn = getAPI<ILGAInConstituencyStates>({
	actionType: constituencyType.getLGAIn,
	url: '/api/v1/ConstituencyLga/getLgasInConstituency',
	type: 'core',
});

// constituency ward

export const createWard = createAPI<undefined, { constituencyId: number; wardId: number }>({
	actionType: constituencyType.createWard,
	url: '/api/v1/ConstituencyWard',
});

export const getWard = getAPI({
	actionType: constituencyType.getWard,
	url: '/api/v1/ConstituencyWard',
	type: 'core',
});

// export const getWardByID =

// ({
//   onFailure,
//   onSuccess,
//   query,
//   paged
// }: IGetQuery) => {
//   return utils.httpPostMethod({
//     apiData: {
//       url: `/api/v1/ConstituencyWard/GetConstituencyWardById${getCommandQuery(
//         paged,
//         ...(query || [])
//       )}`,
//       header: utils.header()
//     },
//     actionType: constituencyType.getWardByID,
//     onSuccess,
//     onFailure
//   })
// }

interface IUpdateWard {
	constituencyId: number;
	wardId: number;
	newConstituencyId: number;
	newWardId: number;
}

export const updateWard = updateAPI<undefined, IUpdateWard>({
	actionType: constituencyType.updateWard,
	url: '/api/v1/ConstituencyWard/update',
});

export const getWards = getAPI<IWardInConsistuency>({
	actionType: constituencyType.getWards,
	url: '/api/v1/ConstituencyWard/getWardsInConstituency',
	type: 'core',
});

export const updateMetaData = updateByIdAPI<undefined, IMetaDataFormHook>({
	actionType: constituencyType.updateMetaData,
	url: '/api/v1/Constituency/updatemetadata',
});

export const getLGAFor = getAPI<ILGAConstituencyStates>({
	actionType: constituencyType.getLGAFor,
	url: '/api/v1/ConstituencyLga/get-constituencies-for-lga',
	type: 'core',
});

export const getForWard = getAPI<IWardConstituencyStates>({
	actionType: constituencyType.getForWard,
	url: '/api/v1/ConstituencyWard/get-constituencies-for-ward',
	type: 'core',
});

export interface IMapConstituencyLGA {
	constituencyId: number;
	lgaIds: number[];
}

export const mapLGA = getFetchAPI<undefined, IMapConstituencyLGA>({
	actionType: constituencyType.mapLGA,
	url: '/api/v1/ConstituencyLga/map-multiple-lgas-to-constituency',
});

export interface IMapConstituencyWard {
	constituencyId: number;
	wardId: number[];
}

export const mapWard = getFetchAPI<undefined, IMapConstituencyWard>({
	actionType: constituencyType.mapWard,
	url: '/api/v1/ConstituencyWard/map-multiple-wards-to-constituency',
});
